import React from 'react'
import { useContext } from 'react'
import "./Loader.css"
import mainContext from '../../../context/mainContext'
import { RotatingTriangles } from 'react-loader-spinner'
import loaderGif from "../../../assets/images/loaderGif.gif"

function LoaderFetch() {
    const { loader: { loaderFetch, setLoaderFetch } } = useContext(mainContext)
    return (
        <div className='fullWin'>
            {/* <RotatingTriangles
                visible={true}
                height="100"
                width="100"
                colors={['#f39c12', '#7d56a5', '#35BFEA']}
                ariaLabel="rotating-triangles-loading"
                wrapperStyle={{}}
                wrapperClass=""
            /> */}
            <img src={loaderGif}
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    translate: "-50% -50%",
                    width: '100%',    // Full width of the viewport
                    maxWidth: "450px",
                }} />
        </div>
    )
}

export default LoaderFetch